import { getUserError } from '../../../components/miscUtils';
import { TpETLFlowManifest } from './interfaces';
import { manifestETLPubmedCaseStudy } from './pubmed-case-study/etlPubmedCaseStudy.Manifest';
import { manifestETLDiseaseGeneCaseStudy } from './disease-gene-case-study/etlDiseaseGeneCaseStudy.Manifest';

export const allETLFlows = [manifestETLPubmedCaseStudy, manifestETLDiseaseGeneCaseStudy];

const manifestLookup: { [id: string]: TpETLFlowManifest } = {};
for (const manifest of allETLFlows) manifestLookup[manifest.id] = manifest;

export function getETLFlow(flowId: string): TpETLFlowManifest {
  if (!manifestLookup[flowId]) throw getUserError(`Invalid flow id: ${flowId}`);
  return manifestLookup[flowId];
}
